export const primary = {
  iconRetinaUrl: require("@/static/map/markers/primary_2x.png"),
  shadowRetinaUrl: require("@/static/map/markers/shadow_2x.png"),
  iconUrl: require("@/static/map/markers/primary.png"),
  shadowUrl: require("@/static/map/markers/shadow.png"),
  shadowSize: [38, 35],
  shadowAnchor: [6, 30],
  popupAnchor: [0, -30],
  iconSize: [29, 41],
  iconAnchor: [15, 40]
};

export const secondary = {
  iconRetinaUrl: require("@/static/map/markers/secondary_2x.png"),
  shadowRetinaUrl: require("@/static/map/markers/shadow_2x.png"),
  iconUrl: require("@/static/map/markers/secondary.png"),
  shadowUrl: require("@/static/map/markers/shadow.png"),
  shadowSize: [38, 35],
  shadowAnchor: [6, 30],
  iconSize: [29, 41],
  popupAnchor: [0, -30],
  iconAnchor: [15, 40]
};

export const numbered = {
  iconRetinaUrl: require("@/static/map/markers/numbered_2x.png"),
  shadowRetinaUrl: require("@/static/map/markers/shadow_2x.png"),
  iconUrl: require("@/static/map/markers/numbered.png"),
  shadowUrl: require("@/static/map/markers/shadow.png"),
  shadowSize: [38, 35],
  shadowAnchor: [6, 30],
  popupAnchor: [0, -30],
  iconSize: [29, 41],
  iconAnchor: [15, 40]
};

export const numberedPrimary = {
  iconRetinaUrl: require("@/static/map/markers/numbered_blue_2x.png"),
  shadowRetinaUrl: require("@/static/map/markers/shadow_2x.png"),
  iconUrl: require("@/static/map/markers/numbered_blue.png"),
  shadowUrl: require("@/static/map/markers/shadow.png"),
  shadowSize: [38, 35],
  shadowAnchor: [6, 30],
  popupAnchor: [0, -30],
  iconSize: [29, 41],
  iconAnchor: [15, 40]
};

export const numberedSecondary = {
  iconRetinaUrl: require("@/static/map/markers/numbered_pink_2x.png"),
  shadowRetinaUrl: require("@/static/map/markers/shadow_2x.png"),
  iconUrl: require("@/static/map/markers/numbered_pink.png"),
  shadowUrl: require("@/static/map/markers/shadow.png"),
  shadowSize: [38, 35],
  shadowAnchor: [6, 30],
  popupAnchor: [0, -30],
  iconSize: [29, 41],
  iconAnchor: [15, 40]
};

export const colored = {
  shadowUrl: require("@/static/map/markers/shadow_alt.png"),
  iconSize: [32, 45],
  iconAnchor: [16, 45],
  className: "color-marker"
};
